import { useState } from "react";
import { PropTypes } from 'prop-types';
import ModelButton from "../modelBtn/modelButton";
import PopupDialog from "./popupDialog";


const EventCard = ({ event, handleEventClick }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        <>
            <div
                className="flex flex-col items-center justify-center border-b border-b-neutral-700 py-8 md:flex-row md:items-start gap-5  md:justify-start cursor-pointer"
                onMouseEnter={handleEventClick}
                onClick={() => (event.paragraphs != null && (modalOpen ? closed() : open()))}
            >
                <div className="flex flex-col gap-5 items-center justify-center md:items-start md:justify-between ">
                    <span className="text-neutral-700 text-xs font-normal text-center md:text-left leading-3">
                        {event.date}
                    </span>
                    <h2 className="text-neutral-700 text-base xl:w-[30rem] font-medium hover:text-red-500 transition-all text-center md:text-left ">
                        {event.title}
                    </h2>
                    <span className="uppercase">Learn More +</span>
                </div>
            </div>
            {
                event.paragraphs != null &&

                <ModelButton modalOpen={modalOpen} close={closed}>
                    <PopupDialog title={event.title} date={event.date} paragraphs={event.paragraphs} />
                </ModelButton>
            }
        </>
    )
}
EventCard.propTypes = {
    event: PropTypes.object,
    handleEventClick: PropTypes.func
}



const Events = ({ events }) => {
    const [selectedEvent, setSelectedEvent] = useState(0);
    const handleEventClick = (index) => {
        setSelectedEvent(index);
    };
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8  w-full">
            <div className="flex flex-col gap-8 w-full">
                {events?.map((event, index) => (
                    <EventCard key={index} event={event} handleEventClick={() => handleEventClick(index)} />
                ))}
            </div>

            <div className="flex flex-col gap-5 w-full">
                <div className="w-full h-[30rem] lg:h-[80%] bg-center bg-cover bg-no-repeat transition-all" style={{ backgroundImage: `url('${events != null ? events[selectedEvent]?.img : ""}')` }}>
                </div>

                <span className="text-neutral-800 text-xl font-bold uppercase flex flex-col gap-3  leading-3">
                    Read Article
                    <svg width="140" height="9" viewBox="0 0 140 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M139.984 4.86914L133.054 0.86815V8.87013L139.984 4.86914ZM0 5.56213H133.747V4.17615H0V5.56213Z" fill="black" />
                    </svg>

                </span>

            </div>


        </div>
    )
}
Events.propTypes = {
    events: PropTypes.array
}
export default Events